import angular, { version } from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('ratingpage2', {
        template: require('./rating-page2.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$location',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function Ctrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $location,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.star_lit = require('Images/star_lit.png');
        vm.star_active = require('Images/star_active.png');
        vm.star_inactive = require('Images/star_inactive.png');

        vm.rating_types = [
            { name: 'Pronunciation',             key:'pronunciation', subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Punctuality',               key:'punctuality',   subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Mastery of Subject Matter', key:'smartness',     subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Teaching Method',           key:'faith',         subtitle: 'How good is the teacher in lorem ipsum'},
            { name: 'Feedback Quality',          key:'helpfulness',   subtitle: 'How good is the teacher in lorem ipsum'},
        ];

        vm.rating_types = [
            { name: '발음',        key:'pronunciation', subtitle: '선생님의 발음이 얼마나 좋은가요?'},
            { name: '시간 엄수',  key:'punctuality',   subtitle: '선생님이 상시 얼마나 잘 제 시간에 수업에 참여하나요?'},
            { name: '주제 숙지',    key:'smartness',     subtitle: '여러분의 선생님은 여러분의 수업에 얼마나 익숙한가요?'},
            { name: '교수법',       key:'faith',         subtitle: '여러분의 선생님은 수업을 얼마나 잘 하나요?'},
            { name: '피드백 품질',   key:'helpfulness',   subtitle: '여러분의 수업에 대한 선생님의 피드백은 얼마나 좋은가요?'},
        ];

        vm.rating_types.forEach(rt => { rt.score = 0; rt._score = 0 });

        vm.teacher_tags = [
            { key: 'tt_conversant',            display: '친숙함' },
            { key: 'tt_great_for_kids',        display: '아이들에게 적합' },
            { key: 'tt_reliable',              display: '신뢰할 수 있음' },
            { key: 'tt_expert',                display: '전문가' },
            { key: 'tt_punctual',              display: '시간 엄수' },
            { key: 'tt_organized',             display: '체계적' },
            { key: 'tt_motivating',            display: '동기부여' },
            { key: 'tt_polite',                display: '정중함' },
            { key: 'tt_firm',                  display: '확고함' },
            { key: 'tt_eloquent',              display: '유창함' }
        ];

        vm.lesson_tags = [
            { key: 'lt_good_material',     display: '좋은 자료' },
            { key: 'lt_fits_my_needs',     display: '나의 필요에 부합함' },
            { key: 'lt_fun',               display: '재미' },
            { key: 'lt_customized',        display: '맞춤 수업' },
            { key: 'lt_helpful',           display: '유용함' },
            { key: 'lt_beginner_friendly', display: '초보자에게 적합' },
            { key: 'lt_challenging', display: '도전 의식을 북돋움' }
        ];

        vm.rating_messages = [
            '별로예요. 수업이 전혀 좋지 않았어요.',
            '괜찮아요. 좋지도 나쁘지도 않았어요.',
            '좋아요. 수업이 만족스러워요.',
            '매우 좋아요. 수업이 순조로웠어요. ',
            '훌륭해요! 저는 수업이 정말 즐거웠어요.',
        ];

        function objectify_tags(tags){
            tags.forEach((v,i,a) => {
                v.clicked = 0;
            })
        }
        objectify_tags(vm.teacher_tags);
        objectify_tags(vm.lesson_tags);

        vm.data = {
            score: 0,
            _score: 0
        }

        vm.id = $stateParams.id;

        vm.back = () => {
            window.history.back();
        }

        vm.get_data = function(){
            
            var request = {
                method: 'GET',
                route: URLS.base + `/regular_class_item/${vm.id}/regular_class`,
            };

            
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.submitted = true;
                        vm.item = response.data.data.data[0];
                        if(!vm.item){
                            vm.id = null;

                        }
                        vm.item.initial_student_name = ''+vm.item.student_name

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.get_data();


        vm.save = () => {

            const data = {
                regular_class_id: vm.item.regular_class_id,
            };

            if(vm.item.initial_student_name != vm.item.student_name){
                data.preferred_name = vm.item.student_name;
            }

            vm.rating_types.forEach((rt) => {
                data[rt.key] = ''+parseInt(Math.max(Math.min(rt.score,5), 1));
            });

            vm.teacher_tags.forEach(tt => {
                if(tt.clicked){
                    data[tt.key] = '1';
                }
            })

            vm.lesson_tags.forEach(lt => {
                if(lt.clicked){
                    data[lt.key] = '1';
                }
            })

            data.review = vm.data.review;
            data.teacher_id = vm.item.teacher_id;
            data.regular_class_item_id = vm.item.regular_class_item_id;

            console.log(data);

            var request = {
                method: 'POST',
                route: URLS.base + `/rating`,
                body: data
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.has_rating = true;
                        vm.get_data();
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                    logger.success('시간을 내어 저희에게 후기를 남겨 주셔서 감사합니다. 이는 저희가 여러분에게 더욱 더 좋은 서비스를 제공할 수 있도록 저희 서비스를 개선하는 데에 도움이 될 것입니다. 좋은 하루 보내세요!')
                });
        }

        vm.change_name_box = () => {
            console.log(vm.item.change_name);
            if(!vm.item.change_name){
                vm.item.student_name = ''+vm.item.initial_student_name;
            }else{
                setTimeout(() => document.getElementById('name_box').select(), 100)
            }
        }

        vm.change_name = () => {
            if(vm.item.student_name != vm.item.initial_student_name){
                vm.item.change_name = true;
            }
        }

        vm.focus_name_box = () => {
            setTimeout(() => document.getElementById('name_box').focus(), 100)
        }
        vm.focused_name_box = (e) => {
            setTimeout(() => document.getElementById('name_box').select(), 100)

        }
        vm.goHome = () => {
            $location.path('home-page');
        };
        vm.close_bigstar = () => {
            document.getElementById('bigstar').style.display = 'none';
        }

        setTimeout(()=>{
            setup_rating_listeners();
        }, 100);
        setInterval(() => {
            vm.rating_types.forEach(rt => {
                draw_ratings(rt);
            });
        }, 100);
        const bscanvas = document.getElementById('bigstar');

        function setup_rating_listeners(){
            vm.rating_types.forEach(rt => {
                const canvas = document.getElementById('canvas_' + rt.key);
                canvas.rating = rt;
                rt.canvas = canvas;
                const ctx = canvas.getContext('2d');
                rt.ctx = ctx;

                canvas.addEventListener('touchend', touchend.bind(null, rt));
                canvas.addEventListener('touchmove', touchmove.bind(null, rt));
                canvas.addEventListener('mousemove', mousemove.bind(null, rt));
                canvas.addEventListener('mouseout', mouseout.bind(null, rt));
                canvas.addEventListener('mousedown', mousedown.bind(null, rt));
                canvas.addEventListener('touchstart', touchstart.bind(null, rt));
            });

            function touchstart(rt, e) {
                console.log('touchstart');
                var rect = e.target.getBoundingClientRect();
                var x = e.targetTouches[0].pageX - rect.left;
                const w = rt.canvas.offsetWidth;

                e.layerX = x;
                rt._score = e.layerX / (w / 4.9) + 1;
                vm.rating = rt;


                // document.getElementById('bigstar').style.display = 'unset';
            }

            function touchmove(rt, e) {
                console.log('touchmove');

                var rect = e.target.getBoundingClientRect();
                var x = e.targetTouches[0].pageX - rect.left;
                const w = rt.canvas.offsetWidth;

                e.layerX = x;
                rt._score = e.layerX / (w / 4.9) + 1;


                // full screen 
                // var x = e.targetTouches[0].clientX;
                // const w = bscanvas.offsetWidth;

                // e.layerX = x;
                // rt._score = e.layerX / (w/5) + 1;
            }

            function touchend(rt, e) {
                console.log('touchend');
                console.log(e);
                var rect = e.target.getBoundingClientRect();
                var x = e.changedTouches[0].pageX - rect.left;
                const w = rt.canvas.offsetWidth;

                e.layerX = x;
                rt._score = e.layerX / (w / 4.9) + 1;
                rt.score = rt._score;
                rt._score = 0;

                vm.rating = null;
                // document.getElementById('bigstar').style.display = 'none';
            }
            function mousedown(rt, e) {
                console.log('mousedown');
                var x = e.offsetX;
                const w = rt.canvas.offsetWidth;
                rt.score = x / (w / 4.9) + 1;
                rt._score = 0;
            }
            function mousemove(rt, e) {
                console.log('mousemove');
                const w = rt.canvas.offsetWidth;

                if(!rt.score)
                rt._score = e.layerX / (w / 4.9) + 1;
                draw_ratings(rt);
            }

            function mouseout(rt){
                console.log('mouseout');
                // rt.score = rt._score;
                rt._score = 0;

                draw_ratings(rt);
            }

        }

        const star_lit = new Image();
        const star_inactive = new Image();
        const star_active = new Image();

        star_lit.src = vm.star_lit;
        star_inactive.src = vm.star_inactive;
        star_active.src = vm.star_active;

        function draw_ratings(rating){

            const canvas = rating.canvas;
            const ctx = rating.ctx;

            const w = canvas.offsetWidth;
            const h = canvas.offsetHeight;

            canvas.width = 340;
            canvas.height = 100;
            const margin_size = 5;
            const star_size = w/5 - margin_size * 1.1;



            for(let i = 1; i <= 5; i++){
                let s;

                if(!rating._score && i < rating.score){
                    s = star_lit;
                }else
                if( i >= rating._score ){
                    s = star_inactive;
                }else{
                    s = star_active;
                }

                ctx.drawImage(s, (i-1) * star_size + margin_size * i, h / 2  - star_size / 2, star_size, star_size);
            }

            if(vm.rating && vm.rating.key == rating.key){

                const bsctx = bscanvas.getContext('2d');
                const bsw = bscanvas.offsetWidth;
                const bsh = bscanvas.offsetHeight;
                const bsstar_size = bsw/5 - margin_size * 1.1;
                
                
                bscanvas.width = bsw;
                bscanvas.height = bsh;
                
                bsctx.clearRect(0, 0, bsw, bsh);
                bsctx.fillStyle = '#000000aa';
                bsctx.fillRect(0, 0, bsw, bsh);

                for(let i = 1; i <= 5; i++){
                    let s;

                    if((!vm.rating._score && i < vm.rating.score) || i == parseInt(vm.rating._score)){
                        s = star_lit;
                    }else if( i >= vm.rating._score ){
                        s = star_inactive;
                    }else{
                        s = star_active;
                    }

                    bsctx.drawImage(s, (i-1) * bsstar_size + margin_size * i, bsh / 4  - bsstar_size / 2, bsstar_size, bsstar_size);
                }

                bsctx.font = 'bold 90px raleway white';
                bsctx.fillStyle = 'white';
                const text = vm.rating.name;
                const text_dimensions = bsctx.measureText(text);

                bsctx.fillText(text, bsw / 2 - text_dimensions.width / 2, bsh/4 - bsstar_size);
            }

        }

    }

})();



// WEBPACK FOOTER //
// ./src/app/components/rating-page2/rating-page2.component.js